document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      document.body.classList.toggle('menu-open', isOpen);
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.textContent = isOpen ? 'Close' : 'Menu';
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const nextValue = Number(input.value) + Number(button.dataset.step);
        input.value = Math.max(Number(input.min || 1), nextValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const button = form && form.querySelector('[type="submit"]');
      const stickyButton = document.querySelector('[data-sticky-add]');
      const prices = document.querySelectorAll('[data-product-price]');
      if (option.dataset.price) prices.forEach((price) => { price.textContent = option.dataset.price; });
      if (button) {
        button.disabled = option.disabled;
        button.textContent = option.disabled ? 'Sold out' : 'Add to cart';
      }
      if (stickyButton) {
        stickyButton.disabled = option.disabled;
        stickyButton.textContent = option.disabled ? 'Sold out' : 'Add to cart';
      }
    });
  });

  document.querySelectorAll('[data-sticky-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const productButton = document.querySelector('.product-details form [type="submit"]');
      if (productButton) productButton.click();
    });
  });
});
